<template>
  <div class="card p-4 shadow-sm">
    <!-- TOAST -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i>
            {{ alerta.mensaje }}
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            @click="cerrarToast"
          ></button>
        </div>
      </div>
    </div>

    <!-- ENCABEZADO -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="m-0">Habitaciones Pendientes de Limpieza</h3>
    </div>

    <!-- TABLA -->
    <div class="table-responsive">
      <table class="table table-bordered text-center align-middle">
        <thead class="table-light">
          <tr>
            <th>Número de Habitación</th>
            <th>Estado de Limpieza</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="pendientes.length === 0">
            <td colspan="3">No hay habitaciones pendientes de limpieza.</td>
          </tr>
          <tr v-for="hab in pendientes" :key="hab.IdReservaHabitacion">
            <td>{{ hab.habitacion?.Numero }}</td>
            <td>
              <span v-if="hab.LimpiezaUrgente === 1" class="badge bg-danger">
                Limpieza Urgente
              </span>
              <span v-else class="badge bg-secondary">
                Pendiente
              </span>
            </td>
            <td>
              <button
                class="btn btn-warning btn-sm"
                :disabled="hab.LimpiezaUrgente === 1"
                @click="marcarUrgente(hab)"
              >
                {{ hab.LimpiezaUrgente === 1 ? 'Ya marcada como prioridad' : 'Marcar como Urgente' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "HabitacionesPendientesLimpieza",
  data() {
    return {
      pendientes: [],
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
  },
  methods: {
    async obtenerPendientes() {
      try {
        const res = await axios.get(`${API_URL}/habitacionesPendientes-limpieza`);
        // Convierte LimpiezaUrgente a número para que funcione correctamente
        this.pendientes = (res.data.pendientes || []).map(h => ({
          ...h,
          LimpiezaUrgente: Number(h.LimpiezaUrgente)
        }));
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al cargar habitaciones.", "danger");
      }
    },
    async marcarUrgente(hab) {
      try {
        await axios.put(`${API_URL}/reservacion-habitacion/${hab.IdReservaHabitacion}/urgente`);
        // Marca en local y muestra alerta
        hab.LimpiezaUrgente = 1;
        this.mostrarAlerta("Habitación marcada como urgente.");
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al marcar como urgente.", "danger");
      }
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
  },
  mounted() {
    this.obtenerPendientes();
  },
};
</script>

<style scoped>
.badge {
  font-size: 0.9rem;
  padding: 0.5em 0.75em;
}
</style>
